CitrusHelperJS = {
    baseURL: "",

    impressionEndpoint: "",

    clickEndpoint: "",

    preparingCarousel: false,

    currentVisibleProdCount: 0,

    SESSION_ID_LOCALSTORAGE_KEY: "CITRUS_SESSION_ID",

    TRACKING_TYPE_IMPRESSION: "IMPRESSION",

    TRACKING_TYPE_CLICK: "CLICK",

    initParams: function(_baseURL, _impressionEndpoint, _clickEndpoint) {
        var catapultNode = document.querySelector('.citruscatapult');
        params = JSON.parse(catapultNode.getAttribute('data-initparams'));

        this.baseURL = params.baseURL;
        this.impressionEndpoint = params.impressionEndpoint;
        this.clickEndpoint = params.clickEndpoint;
    },

    prepareCatapultCarousel: function() {

        if (this.preparingCarousel) {
            console.log("Another call to prepareCatapultCarousel still in progress.");
            return;
        }
        this.preparingCarousel = true;

        var catapultProducts = [];
        var catapultPartnumbers = [];
        var tempCatapultProducts = document.querySelectorAll(".citruscatapult__product");
        for (var i = 0; i < tempCatapultProducts.length; i++) {
            var tempCatapultProduct = tempCatapultProducts[i];
            var tempCatapultPartnumber = tempCatapultProduct.dataset.partnumber;
            if (!catapultPartnumbers.includes(tempCatapultPartnumber)) {
                catapultProducts.push(tempCatapultProduct);
                catapultPartnumbers.push(tempCatapultPartnumber);
            }
        }

        var total_count = catapultProducts.length;

        var visible_count = 2;
        if (window.innerWidth <= 549 || (window.innerWidth >= 768 && window.innerWidth <= 1023)) {
            visible_count = 1;
        } else if (window.innerWidth >= 1460) {
            visible_count = (total_count >= 3) ? 3 : total_count;
        }
        if (this.currentVisibleProdCount == visible_count) {
            console.log("There is no change in the visible product count.");
            return;
        }

        var carouselItems = document.querySelectorAll('.citruscatapult__product__container .item');
        for (var i = 0; i < carouselItems.length; i++) {
            carouselItems[i].parentNode.removeChild(carouselItems[i]);
        }
        var catapultProductParent = document.querySelector('.citruscatapult__product__container');
        for (var i = 0; i < total_count; i++) {
            const carouselItem = document.createElement("div");
            carouselItem.className = (i == 0) ? 'item active' : 'item';
            for (var j = 0; j < visible_count; j++) {
                if (i + j >= total_count) {
                    break;
                }
                var clonedNode = catapultProducts[i + j].cloneNode(true);
                carouselItem.appendChild(clonedNode);
            }
            catapultProductParent.appendChild(carouselItem);
            if (i + visible_count >= total_count) {
                break;
            }
        }
        this.currentVisibleProdCount = visible_count;
        this.preparingCarousel = false;
    },

    triggerCatapultTracking: function(catapultNode, trackingType) {
        var citrusSessionObj = localStorage.getItem(this.SESSION_ID_LOCALSTORAGE_KEY);
        if (citrusSessionObj) {
            citrusSessionObj = JSON.parse(citrusSessionObj);
            var sessionId = citrusSessionObj.id;
            var endpoint = null;
            switch (trackingType) {
                case this.TRACKING_TYPE_IMPRESSION:
                    endpoint = this.baseURL + this.impressionEndpoint
                    break;
                case this.TRACKING_TYPE_CLICK:
                    endpoint = this.baseURL + this.clickEndpoint
                    break;
            }
            if (endpoint) {
                endpoint += '/' + catapultNode.getAttribute('data-adId') + '?sessionId=' + sessionId + '&event_ts=' + new Date().toISOString();
                $.get(endpoint, function(data) {
                    console.log(data);
                });
            } else {
                console.log('ERROR: Invalid trackingType ' + trackingType);
            }
        } else {
            console.log('ERROR: local storage item "CITRUS_SESSION_ID" missing ');
        }
    },

    triggerCatapultImpression: function(catapultNode) {
        this.triggerCatapultTracking(catapultNode, this.TRACKING_TYPE_IMPRESSION);
    },

    triggerCatapultClick: function(catapultNode) {
        this.triggerCatapultTracking(catapultNode, this.TRACKING_TYPE_CLICK);
    },

    initializeTrackingListeners: function() {
        var catapultNode = document.querySelector('.citruscatapult');
        if (catapultNode) {
            if ("IntersectionObserver" in window) {
                var observer = new IntersectionObserver(function(e, t) {
                    e.forEach(function(e) {
                        if (e.isIntersecting) {
                            CitrusHelperJS.triggerCatapultImpression(e.target);
                            observer.unobserve(e.target);
                        }
                    })
                });
                observer.observe(catapultNode);
            } else {
                CitrusHelperJS.triggerCatapultImpression(catapultNode);
            }
            var elementsToTrackClick = [].slice.call(document.querySelectorAll('.citruscatapult a:not(.citruscatapult__rightcontent__carousel-cntrl)'));
            elementsToTrackClick.forEach(function(elem) {
                elem.addEventListener("click", function(event) {
                    CitrusHelperJS.triggerCatapultClick(document.querySelector('.citruscatapult'));
                });
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    if (document.querySelector('.citruscatapult')) {
        CitrusHelperJS.initParams();
        CitrusHelperJS.prepareCatapultCarousel();
        window.addEventListener("resize", CitrusHelperJS.prepareCatapultCarousel());
        CitrusHelperJS.initializeTrackingListeners();
        $('#citruscatapult-product-carousel').bind('slide.bs.carousel', function(e) {
            $('.citruscatapult__product__container .item.active .citruscatapult__product').addClass('revertopacity');
            $('.citruscatapult__product__container .item.active .citruscatapult__product').css('opacity', '0.1');
        });
        $('#citruscatapult-product-carousel').bind('slid.bs.carousel', function(e) {
            $('.citruscatapult__rightcontent__carousel-cntrl').removeClass('disabled');
            if ($('.citruscatapult__product__container .item:first-child').hasClass('active')) {
                $('.citruscatapult__rightcontent__carousel-cntrl.prev').addClass('disabled');
            } else if ($('.citruscatapult__product__container .item:last-child').hasClass('active')) {
                $('.citruscatapult__rightcontent__carousel-cntrl.next').addClass('disabled');
            }
            $('.citruscatapult__product__container .item.active .citruscatapult__product.revertopacity').css('opacity', 'unset');
            $('.citruscatapult__product__container .item.active .citruscatapult__product.revertopacity').removeClass('revertopacity');
        });
    }
});
